import { Spacing } from '@abgov/angular-components';
import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'd3-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
})
export class D3DetailsComponent {
  @Input() title: string;
  @Input() marginTop: Spacing | undefined = 'm';
  defaultTitle = 'Click here for more information';
}
